var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3199.091-716.607 109.876 20.427-8.124 96.449-128.262-54.604z",
    style: {
      fill: "#fffb96",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1149 422.362h260v237h-260z",
    style: {
      opacity: 1,
      fill: "#8c00f1",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1419.852 875.87c2.25 34.47-6.15 74.265 44.626 84.47 37.612-1.106 57.458-27.086 52.595-87.657z",
    style: {
      fill: "#580098",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1460.833 612.895-25.916 70.127h20.157l-24.476 54.189 23.036-1.594-24.476 51.001 322.51-1.594-23.036-49.407 25.915-1.594c-42.08-79.9-67.603-102.78-136.654-100.497z",
    style: {
      fill: "#ffe001",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1402.326 423.24c-103.183 23.752-104.064 102.11 0 106.777z",
    style: {
      fill: "#ff009e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.27665 0 0 .27665 -3055.707 309.147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12583.487-534.822c286.505 65.953 288.951 283.524 0 296.486z",
    style: {
      fill: "#ff009e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11726.433 39.216c-105.572 20.064-156.444 111.509-151.328 179.095 0 0-47.648.83-52.757 0-5.713-65.54 11.743-156.71 119.397-208.25-53.029-27.845-102.434-27.913-144.387 29.155l-37.485-34.709c39.235-44.528 81.963-85.562 208.25-43.038-32.85-89.741-90.595-101.689-152.716-99.96l1.388-54.145c165.956 1.842 190.583 90.481 207.345 186.934z",
    style: {
      fill: "#8c00f1",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12384.022-500.896c191.51-266.879 292.865-393.147 223.655-451.245-72.573-60.923-189.243 60.065-456.52 272.24l116.433 89.503z",
    style: {
      fill: "#008298",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12583.487-534.822c286.505 65.953 288.951 283.524 0 296.486z",
    style: {
      fill: "#98005e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11946.243 726.408c-6.245 95.712 17.078 206.208-123.912 234.547-104.436-3.074-159.541-75.21-146.039-243.398z",
    style: {
      fill: "#580098",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11919.69 398.927 97.36 212.42-70.807 4.425 70.807 146.04-411.564-4.426 70.806-141.614h-75.232l132.763-247.823z",
    style: {
      fill: "#98005e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12534.823 721.983c-6.244 95.712 17.078 206.207-123.912 234.547-104.436-3.074-159.541-75.21-146.038-243.398z",
    style: {
      fill: "#580098",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12596.779 757.386h-398.288l70.807-137.188-70.807-4.426 115.061-252.248 199.144 22.127 79.658 225.696h-57.531z",
    style: {
      fill: "#98005e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12508.271-8.211 79.657 194.718h-61.956l75.232 150.464-70.806-4.425 75.232 141.613-991.293-4.425 70.806-137.188-79.657-4.426c129.339-221.856 172.772-285.141 385.011-278.8z",
    style: {
      fill: "#988400",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12592.354 49.32h-606.283l70.807-141.614h-75.232l101.785-199.144h446.967l70.806 199.144h-75.232z",
    style: {
      fill: "#008298",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.065 875.87c1.762 34.47-4.818 74.265 34.961 84.47 29.466-1.106 45.014-27.086 41.204-87.657z",
    clipPath: "url(#a)",
    style: {
      fill: "#8c00f1",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(-2.77667 0 0 2.77667 16477.283 -1710.019)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12504.734 757.386h-306.243l54.444-137.188-54.444-4.426 88.47-252.248 153.121 22.127 61.249 225.696h-44.235z",
    style: {
      fill: "#ff009e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.065 875.87c1.762 34.47-4.818 74.265 34.961 84.47 29.466-1.106 45.014-27.086 41.204-87.657z",
    clipPath: "url(#a)",
    style: {
      fill: "#8c00f1",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(-2.77667 0 0 2.77667 15888.702 -1705.593)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11915.632 760.162h-314.572l55.924-138.154-55.924-4.457 90.876-254.027 157.286 22.283 62.915 227.287h-45.438z",
    style: {
      fill: "#ff009e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12421.033-8.211 71.96 194.718h-55.969l67.962 150.464-63.964-4.425 67.962 141.613-895.503-4.425 63.964-137.188-71.959-4.426c116.841-221.856 187.712-285.386 379.442-279.046z",
    style: {
      fill: "#ffe001",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12484.055 49.32h-498.769l58.251-141.614h-61.891l83.735-199.144h367.705l58.249 199.144h-61.89z",
    style: {
      fill: "#00bedd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -12395.332,
    cy: -435.586,
    r: 65.714,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -12395.332,
    cy: -435.586,
    r: 32.857,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 5.657,
    x: 3135.63,
    y: -656.798,
    clipPath: "url(#b)",
    ry: 5,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-4.38094 4.38094) rotate(-23.06 1620.537 14461.46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1329.504 470.16 28.688 58.127h-22.313l27.095 54.189-25.5-1.594 27.094 51.001-357.009-1.594 25.5-49.407-28.687-1.594c46.58-79.9 62.223-90.692 138.66-88.408l92.706-8.062z",
    clipPath: "url(#c)",
    style: {
      fill: "#ffe000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(-2.77667 0 0 2.77667 15416.651 -1291.478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1480.962 715.36-16.994-16.994-14.496 14.422-14.497 14.42-4.696-4.902-4.697-4.902 19.177-19.117 19.177-19.118 16.19 16.123c8.905 8.868 16.948 16.123 17.872 16.123.924 0 8.965-7.254 17.869-16.12l16.188-16.121 16.592 16.523 16.591 16.523 16.188-16.121c8.904-8.866 16.945-16.12 17.87-16.12.924 0 8.965 7.254 17.868 16.12l16.188 16.12 16.592-16.522 16.592-16.523 16.188 16.12c8.903 8.867 16.945 16.121 17.869 16.121.924 0 8.966-7.255 17.871-16.123l16.19-16.123 19.177 19.118 19.178 19.117-4.697 4.902-4.697 4.903-14.485-14.41-14.486-14.411-17.047 16.983-17.047 16.982-16.995-16.995-16.996-16.996-16.484 16.416-16.485 16.416-17.025-16.113-17.026-16.113-16.692 16.693-16.693 16.692-17.05-16.985-17.05-16.986-17.049 16.986-17.05 16.985-16.993-16.993z",
    clipPath: "url(#d)",
    style: {
      fill: "#000"
    },
    transform: "matrix(-2.77667 0 0 2.77667 16477.283 -1710.019)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.336 394.74c-119.128 27.423-120.145 117.888 0 123.277z",
    clipPath: "url(#e)",
    style: {
      fill: "#ff009e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(-2.77667 0 0 2.77667 16477.283 -1710.019)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12364.749-521.352c53.834-324.04 88.944-482.103 1.183-503.629-92.027-22.573-143.209 137.521-289.185 445.979l144.001 28.825z",
    style: {
      fill: "#00bedd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12508.271-8.211 79.657 194.718h-61.956l75.232 150.464-70.806-4.425 75.232 141.613-991.293-4.425 70.806-137.188-79.657-4.426c129.339-221.856 172.772-285.141 385.011-278.8z",
    style: {
      fill: "#988400",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12592.354 49.32h-606.283l70.807-141.614h-75.232l101.785-199.144h446.967l70.806 199.144h-75.232z",
    style: {
      fill: "#008298",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12421.033-8.211 71.96 194.718h-55.969l67.962 150.464-63.964-4.425 67.962 141.613-895.503-4.425 63.964-137.188-71.959-4.426c116.841-221.856 187.712-285.386 379.442-279.046z",
    style: {
      fill: "#ffe001",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12484.055 49.32h-498.769l58.251-141.614h-61.891l83.735-199.144h367.705l58.249 199.144h-61.89z",
    style: {
      fill: "#00bedd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12583.503-534.836-477.945-106.21-119.336 237.511 66.096 1.293-79.523 163.909h610.708V-460.71z",
    style: {
      fill: "#ffe000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -12395.332,
    cy: -435.586,
    r: 65.714,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -12395.332,
    cy: -435.586,
    r: 32.857,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 5.657,
    x: 3135.63,
    y: -656.798,
    clipPath: "url(#b)",
    ry: 5,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-4.38094 4.38094) rotate(-23.06 1620.537 14461.46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1329.504 470.16 28.688 58.127h-22.313l27.095 54.189-25.5-1.594 27.094 51.001-357.009-1.594 25.5-49.407-28.687-1.594c46.58-79.9 62.223-90.692 138.66-88.408l92.706-8.062z",
    clipPath: "url(#c)",
    style: {
      fill: "#ffe000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(-2.77667 0 0 2.77667 15416.651 -1291.478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1480.962 715.36-16.994-16.994-14.496 14.422-14.497 14.42-4.696-4.902-4.697-4.902 19.177-19.117 19.177-19.118 16.19 16.123c8.905 8.868 16.948 16.123 17.872 16.123.924 0 8.965-7.254 17.869-16.12l16.188-16.121 16.592 16.523 16.591 16.523 16.188-16.121c8.904-8.866 16.945-16.12 17.87-16.12.924 0 8.965 7.254 17.868 16.12l16.188 16.12 16.592-16.522 16.592-16.523 16.188 16.12c8.903 8.867 16.945 16.121 17.869 16.121.924 0 8.966-7.255 17.871-16.123l16.19-16.123 19.177 19.118 19.178 19.117-4.697 4.902-4.697 4.903-14.485-14.41-14.486-14.411-17.047 16.983-17.047 16.982-16.995-16.995-16.996-16.996-16.484 16.416-16.485 16.416-17.025-16.113-17.026-16.113-16.692 16.693-16.693 16.692-17.05-16.985-17.05-16.986-17.049 16.986-17.05 16.985-16.993-16.993z",
    clipPath: "url(#d)",
    style: {
      fill: "#000"
    },
    transform: "matrix(-2.77667 0 0 2.77667 16477.283 -1710.019)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4c54e595adb388218563af0768fec92c.svg";
export { ForwardRef as ReactComponent };